import { Theme } from '@mui/material'

const useStyles = {
  majorChip: (theme: Theme) => ({
    backgroundColor: theme.palette.warning.main,
  }),
  minorChip: (theme: Theme) => ({
    backgroundColor: theme.palette.primary.main,
  }),
  releaseChip: (theme: Theme) => ({
    borderRadius: theme.shape.largeBorderRadius,
    color: theme.palette.common.white,
    textTransform: 'capitalize',
    height: '22px',
  }),
  errorMessage: (theme: Theme) => ({
    marginTop: theme.spacing(8),
  }),
  date: (theme: Theme) => ({
    marginLeft: theme.spacing(1),
  }),
  divider: (theme: Theme) => ({
    width: '100%',
    marginTop: theme.spacing(3),
  }),
  contentList: (theme: Theme) => ({
    margin: 0,
    'li:not(:lastChild)': {
      marginBottom: theme.spacing(1),
    },
  }),
  copyIcon: {
    fontSize: '16px',
  },
  copyIconButton: (theme: Theme) => ({
    padding: 0,
    marginLeft: theme.spacing(1),
    width: '24px',
    height: '24px',
  }),
}
export default useStyles
